<template>
  <div class="page dashboard order-details">
    <div class="content">
      <div class="title-bar" style="justify-content: normal;">
        <p class="title">Order Details ({{ order.orderId }})</p>
        <div class="icon" style="
            background-image: url(/icons/copy-text.png); 
            background-size: contain;
            background-repeat: no-repeat;
            margin-left: 12px;
            cursor: pointer;
            width: 2rem; 
            height: 2rem;"

            @click="copy(order.orderId, 'ID ')"
        >
        </div>
        <div
          class="icon"
          style="
            background-image: url(/icons/printer.png);
            background-size: contain;
            background-repeat: no-repeat;
            margin-left: 12px;
            cursor: pointer;
            width: 2rem;
            height: 2rem;
          "
          @click="printOrder()"
        ></div>
      </div>
      <router-link to="/orders">Back</router-link>
      <p v-if="isLoading">Fetching Data . . .</p>
      <div class="page-content" v-if="!isLoading">
        <div class="order-info">
          <div class="user-info">
            <p class="bold">
              UserName:
              {{ order.createBy ? order.createBy.name : "(Deleted Account)" }}
            </p>
            <p>
              Receiver Name: {{ order.shippingDetail.name }}
              {{ order.shippingDetail.lastname }}
            </p>
            <p>
              PHone Number:
              {{ order.shippingDetail.phoneNumber }}
            </p>
          </div>
          <div class="shipping-info">
            <p class="bold">Shipping:</p>
            <p v-if="locationLinkMap">
                <div :style="locationLinkMap ? 'display: flex;' : 'display: none;'">
                    Map: 
                    <a style="color: #4646bb; margin-left: 6px;" :href="locationLinkMap" target="_blank">view</a>
                    <div class="icon" style="
                        background-image: url(/icons/copy-text.png); 
                        background-size: contain;
                        background-repeat: no-repeat;
                        cursor: pointer;
                        width: 1rem; 
                        height: 1rem;
                        margin-left: 3px;
                        margin-top: 5px;"

                        @click="copy(locationLinkMap, 'Map ')"
                    >
                    </div>
                </div>
            </p>
            <p>Address: {{ order.shippingDetail.address }}</p>
            <p v-if="order.shippingDetail.remark">Remark: {{ order.shippingDetail.remark }}</p>
            <p v-if="order.shippingDetail.region != '[object Object]'">Region: {{ order.shippingDetail.region }}</p>
            <!-- <p>Country: {{ order.shippingDetail.country }}</p> -->
            <!-- <p>PostalCode: {{ order.shippingDetail.postalCode }}</p> -->
          </div>
          <div class="shipping-methods">
            <p class="bold">Shipping Setting</p>
            <p>Shipping Method: {{ order.shippingMethod.name }}</p>
            <p>
              Delivery Method:
              {{
              order.transportMethod === 0 ? "Self-pickup" : "Nokor delivery"
              }}
            </p>
            <p>Insurance: {{ order.insurance ? "Yes" : "No" }}</p>
          </div>
            <div class="shipping-methods">
                <p class="bold">
                    <span style="float: left;"> Payment </span>                            
                </p>
                <br>
                <p>Status: 
                    <span v-if="transaction.paid_amount == 0" :class="transaction.confirmedPaymentAt || isConfirmPayment ? 'text-success' : 'text-warning'">{{ transaction.confirmedPaymentAt || isConfirmPayment ? "Confirmed" : "Pending" }}</span>
                    <span v-else class="text-success">Paid</span>
                </p>
                <p v-if="transaction.localDeliveryCost > 0">Delivery Cost: {{(transaction.localDeliveryCost).toFixed(2)}}</p>
                <p v-if="transaction.totalInsurance > 0">Total Insurance: {{(transaction.totalInsurance).toFixed(2)}}</p>
                <p v-if="transaction.totalServiceCost > 0">Total Service Cost: {{(transaction.totalServiceCost).toFixed(2)}}</p>
                <p>Total: {{transaction.total}}</p>
                <img
                    v-for="image in transaction.transactionUploadImages" :key="image"
                    class="order-image"
                    :src="`${API_URL}/${image.image}`"
                    data-lity 
                    :data-lity-target="`${API_URL}/${image.image}`"
                    width="50px"
                    style="cursor: pointer;"
                    alt=""
                />
            </div>
            <div class="payment-confirmation">
                <p class="bold text-danger">
                    <span style="float: left;"> Refund Images</span>                            
                </p>
                <br>
                <img
                    v-for="image in order.refundImages" :key="image"
                    class="order-image"
                    :src="`${API_URL}/${image.image}`"
                    data-lity 
                    :data-lity-target="`${API_URL}/${image.image}`"
                    width="50px"
                    style="cursor: pointer; margin-right: 5px"
                    alt=""
                />
                <br>
                <button
                @click="openUploadFundImageModel"
                class="btn pay"
                v-if="order.status < 5"
                >Upload Image</button>
            </div>
        </div>
        <div class="items-list">
          <div class="status">
            <p class="bold">Order Status:</p>
            <p v-if="updatingStatus">Updating Status . . .</p>
            <div class="status-list" v-if="order.status === 9">
              <p>Rejected</p>
            </div>
            <div class="status-list" v-if="!updatingStatus && order.status !== 9">
              <p v-on:click="updateOrderStatus(0)" :class="`btn active`">Pending</p>
              <p
                v-on:click="updateOrderStatus(7)"
                :class="`btn ${order.status > 6 ? 'active' : ''}`"
              >Delivering</p>
              <p
                v-on:click="updateOrderStatus(8)"
                :class="`btn ${order.status > 7 ? 'active' : ''}`"
              >Completed</p>
            </div>
          </div>
          <p class="bold big">
              Items 
              <span @click="rejectOrder" v-if="isCanReject" class="btn refund" style="width: 90px; background-color: #dc3545; color: #ffffff; text-align: center; padding: 0 10px;">Reject</span>
                </p>
                
          <div class="product-list">
            <div class="product-item" :style="product.itemId == itemId ? 'border: 1px solid red;' : null" v-for="(product, index) in order.orderItems" :key="index">
              <div class="text_num" style="background: #333; color: #fff; padding: .1rem .4rem; border-radius: .2rem;">
                <ul>
                  <li>{{ index + 1 }}</li>
                </ul>
              </div>
              <img :src="`${API_URL}/${product.product.mainImage}`" alt class="image" />
              <div class="product-info">
                  <div style="width:60%; display:inline-block;">
                    <p class="small bold">{{ product.product.name }} <span style="font-size: 1rem;">(x {{ product.amount }})</span></p>

                    <p class="small" v-for="variation in product.product.variations" :key="variation.name">
                        {{ variation.name }}: {{ variation.data[0].value }}
                        <img :src="variation.data[0].image" v-if="variation.data[0].image" data-lity :data-lity-target="variation.data[0].image" alt style="width:32px; height: 32px" />
                    </p>
                    <p class="small bold">
                    Price:
                    {{
                    product.product.price.maxPrice
                    ? `$ ${product.product.price.maxPrice}/per unit`
                    : "Unknown"
                    }}
                    </p>
                    <p class="small bold" v-if="product.serviceCost > 0">Service Cost: $ {{ product.serviceCost }}</p>
                    <p
                    class="small bold"
                    v-if="product.insuranceCost"
                    >Insurance Cost: $ {{ product.insuranceCost }}</p>
                    <a target="_blank" v-if="product.product.url && product.product.url.includes('http')" :href="product.product.url" class="link bold">Check Product</a>
                  </div>
              </div>
              <div class="btn-group">
                <p
                  v-if="product.isApproved && [0, 1, 2, 3, 4, 5, 6, 7].includes(order.status)"
                  v-on:click="refundOrderItem(product.itemId)"
                  class="btn refund" style="width: 90px"
                >Refund</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <UpdateCostModal
      v-if="updateCostModalOpened"
      :closeModal="closeUpdateCostModal"
      :onSubmit="updateExtraPrice"
      :otherCost="order.otherCost"
      :chineseShippingCost="order.chineseShippingCost"
      :internationalShippingCost="order.internationalShippingCost"
      :localDeliveryCost="order.localDeliveryCost"
    />
    <UploadFileModal
        v-if="uploadFundImageModelOpened" 
        :closeModal="closeUploadFundImageModel"
        :handleFormSubmit="uploadFundImageModelSubmit"
    />
  </div>
</template>

<script>
import UpdateCostModal from './UpdateCostModal'
require('lity');
import { API_URL } from "../../const";
import { FileUpload } from "../../handler";
import UploadFileModal from '../../components/UploadFileModal'
import moment from "moment";
export default {
    components: {
        UpdateCostModal,
        FileUpload,
        UploadFileModal
    },
	data() {
    
		return {
			isLoading: true,
      updatingStatus: false,
      updateCostModalOpened: false,
      uploadFundImageModelOpened: false,
      API_URL:API_URL,
      itemId: this.$route.query.itemId
		};
	},
	async created() {
		await this.getOrderDetails();
    await this.getTransactionDetails(this.$store.state.orderModule.orderDetails.transaction);
	},
	methods: {
        printOrder() {
          this.$router.push({ path: `/order/${this.order._id}/print` });
        },
        getNextStatus(status) {
            switch(status) {
                case 0:
                    return 'Ordering';
                case 1:
                    return 'In China';
                case 2:
                    return 'Shipping';
                case 3:
                    return 'In Cambodia';
            }
            return null;
        },
        copy(text, label) {
            if (window.clipboardData && window.clipboardData.setData) {
                alert('Copy ' + label + 'successfully');
                // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
                return window.clipboardData.setData("Text", text);
            } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                var textarea = document.createElement("textarea");
                textarea.textContent = text;
                textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in Microsoft Edge.
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    alert('Copy ' + label + 'successfully');
                    return document.execCommand("copy"); // Security exception may be thrown by some browsers.
                } catch (ex) {
                    alert('Copy failed');
                    console.warn("Copy to clipboard failed.", ex);
                    return false;
                } finally {
                    document.body.removeChild(textarea);
                }
            }
        },
        async uploadFundImageModelSubmit(file) {
            if(file) {
                this.uploadFundImageModelOpened = false;
                const fileObj = await FileUpload.uploadFile(file);
                const success = await this.$store.dispatch("orderModule/uploadRefundImage", {
                    image: fileObj.path,
                    id: this.order._id
                });
                if(success) {
                    alert('Upload refund image successfully');
                } else {
                    alert('Error something went wrong.');
                }
            }
        },
        openUploadFundImageModel() {
            this.uploadFundImageModelOpened = true;
        },
        closeUploadFundImageModel() {
            this.uploadFundImageModelOpened = false;
        },
        closeUpdateCostModal() {
            this.updateCostModalOpened = false
        },
        openUpdateCostModal() {
            this.updateCostModalOpened = true
        },
        async updateOrderArrival(itemId) {
            const confirmed = confirm("Are you sure this order has arrived?");
            if(confirmed) {
                this.$store.dispatch('orderModule/orderArrived', {_id: this.orderId, itemId})
            }
        },
		async getOrderDetails() {
			await this.$store.dispatch("orderModule/getOrderDetails", {
				_id: this.orderId,
			});
			this.isLoading = false;
		},
    async getTransactionDetails(transactionId) {
        if(transactionId) {
            await this.$store.dispatch("transactionsModule/getTransactionDetails", {
                _id: transactionId,
            });
            this.isLoading = false;
        }
    },
		async updateOrderStatus(status) {
			const confirmed = confirm("Are you sure you want to updated status?");
			if (confirmed) {
				this.updatingStatus = true;
				await this.$store.dispatch("orderModule/updateStatus", {
					_id: this.order._id,
					status,
				});
				this.updatingStatus = false;
			}
		},
		async refundOrderItem(itemId) {
			const confirmed = confirm('Are you sure you want to refund this item?')
			if (confirmed) {
				this.$store.dispatch('orderModule/refundOrderItem', {orderId: this.orderId, itemId})
			}
		},
		async noteOrderItem(itemId, note) {
			const confirmed = confirm('Are you sure you want to note this item?')
			if (confirmed) {
				this.$store.dispatch('orderModule/noteOrderItem', {orderId: this.orderId, itemId, note})
			}
		},
        async arrivedCambodia(itemId) {
            const item = this.order.orderItems.find(item => item.itemId == itemId);

            if(item && item.status == 3) {
			    const confirmed = confirm('Are you sure this item arrived in cambodia?')
                
                if (confirmed) {
                    this.$store.dispatch('orderModule/nextStatusOrderItem', {
                        orderId: this.orderId, 
                        itemId,
                        date: moment().format('YYYY-MM-DD h:mm A')
                    });
                }
            }
        },
		async nextStatusOrderItem(itemId, trackingId, date, chinaMoney) {
			const confirmed = confirm('Are you sure you want to update status this item?')
			if (confirmed) {
                date = date ? moment(date) : moment();
				this.$store.dispatch('orderModule/nextStatusOrderItem', {
                    orderId: this.orderId, 
                    itemId,
                    date: date.format('YYYY-MM-DD h:mm A'),
                    trackingId,
                    chinaMoney
                })
			}
		},

        async updateTrackingIdOrderItem(itemId, trackingId) {
            const confirmed = confirm(
                "Are you sure you want to update tracking id this item?"
            );
            if (confirmed) {
                const success = await this.$store.dispatch("orderModule/trackingIdOrderItem", {
                orderId: this.orderId,
                itemId,
                trackingId,
                });

                if(success) {
                    alert('Update tracking id suceesfully')
                } else {
                    alert('Fail to update tracking id')
                }
            }
        },
		async updateExtraPrice(
			{otherCost,
			localDeliveryCost,
			internationalShippingCost,
			chineseShippingCost}
		) {
			const done = await this.$store.dispatch("orderModule/updateCost", {
				_id: this.orderId,
				otherCost,
				localDeliveryCost,
				internationalShippingCost,
				chineseShippingCost,
      });
      if (done) {
        this.getOrderDetails()
        this.closeUpdateCostModal()
        alert("Updated")
      }
		},
		async payOrder() {
			const confirmed = confirm(
				"Are you sure, this order is already completed 2nd payment?"
			);
			if (confirmed) {
				const done = await this.$store.dispatch("orderModule/payOrder", {
					_id: this.orderId,
				});
				if (done) {
					this.getOrderDetails();
				}
			}
        },
		async rejectOrder() {
			const confirmed = confirm(
				"Are you sure, you want to reject all item in this order?"
			);
			if (confirmed) {
				const done = await this.$store.dispatch("orderModule/rejectOrder", {
					_id: this.orderId,
				});
				if (done) {
					this.getOrderDetails();
				}
			}
        },
	},
	computed: {
		orderId() {
			return this.$route.params.id;
		},
		order() {
			return this.$store.state.orderModule.orderDetails;
		},
    transaction() {
        let transaction = this.$store.state.transactionsModule.transactionDetails;
        let total = 0;
        total += transaction.localDeliveryCost;
        let totalInsurance = 0;
        let totalServiceCost = 0;
        transaction.transactionItems?.map((i) => {
            total += ((i.product.price.maxPrice * i.amount) + i.serviceCost + i.insuranceCost);
            totalInsurance += i.insuranceCost;
            totalServiceCost += i.serviceCost;
        });
        transaction.total = total;
        transaction.totalInsurance = totalInsurance;
        transaction.totalServiceCost = totalServiceCost;
        return transaction
    },
    currentUser() {
        return this.$store.state.usersModule.currentUser;
    },
    isCanReject() {
        if(this.order.status === 9) {
            return false;
        }

        if(this.currentUser.role.name !== 'admin' && this.currentUser.role.name !== 'financer') {
            return false;
        }

        const isHasApproved = this.order.orderItems.findIndex(item => {
            return item.isApproved;
        })

        return isHasApproved === -1;
    },
    mainImagePath(){
      return this.product?.mainImage?.path || this.getAPIImage(this.product.mainImage);
    },
    locationLinkMap()
    {
        if(!this.order.shippingDetail.location) {
            return false;
        }

        if(this.order.shippingDetail.location.latitude == 0 && this.order.shippingDetail.location.longitude == 0) {
            return false;
        }

        return `https://www.google.com/maps/search/?api=1&query=${this.order.shippingDetail.location.latitude},${this.order.shippingDetail.location.longitude}`;
    }
	},
};
</script>

<style src="lity/dist/lity.min.css"></style>
<style scoped>
    .not-allow {
        cursor: not-allowed;
    }
</style>
